// Navigation Component
export function initNavigation() {
  const header = {
    element: null,
    mobileMenu: null,
    hamburger: null,
    navLinks: null,

    init() {
      console.log("🧭 Navigation init started");
      this.element = document.getElementById("header");
      this.mobileMenu = document.getElementById("mobile-menu");
      this.hamburger = document.getElementById("hamburger");
      this.navLinks = document.querySelectorAll(".nav-link");

      this.bindEvents();
      this.handleScroll();
    },

    bindEvents() {
      // Mobile menu toggle
      if (this.hamburger) {
        this.hamburger.addEventListener("click", this.toggleMobileMenu.bind(this));
      }

      // Navigation links
      this.navLinks.forEach((link) => {
        link.addEventListener("click", this.handleNavClick.bind(this));
      });

      // Scroll events
      window.addEventListener("scroll", this.throttle(this.handleScroll.bind(this), 10));

      // Close mobile menu on resize
      window.addEventListener("resize", this.debounce(() => {
        if (window.innerWidth >= 768) {
          this.closeMobileMenu();
        }
      }, 250));
    },

    toggleMobileMenu() {
      this.hamburger.classList.toggle("active");
      this.mobileMenu.classList.toggle("active");
      document.body.classList.toggle("no-scroll");
    },

    closeMobileMenu() {
      this.hamburger?.classList.remove("active");
      this.mobileMenu?.classList.remove("active");
      document.body.classList.remove("no-scroll");
    },

    handleNavClick(e) {
      e.preventDefault();
      const href = e.target.getAttribute("href");

      if (href.startsWith("#")) {
        const targetElement = document.querySelector(href);
        if (targetElement) {
          this.smoothScrollTo(targetElement);
          this.closeMobileMenu();

          // Update active nav link
          this.navLinks.forEach((link) => link.classList.remove("active"));
          e.target.classList.add("active");
        }
      } else {
        location.href = href;
      }
    },

    handleScroll() {
      if (!this.element) return;

      const scrolled = window.pageYOffset > 50;
      this.element.classList.toggle("scrolled", scrolled);
    },

    // Utility functions
    throttle(func, limit) {
      let inThrottle;
      return function() {
        const args = arguments;
        const context = this;
        if (!inThrottle) {
          func.apply(context, args);
          inThrottle = true;
          setTimeout(() => (inThrottle = false), limit);
        }
      };
    },

    debounce(func, wait, immediate) {
      let timeout;
      return function executedFunction() {
        const context = this;
        const args = arguments;
        const later = function() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    },

    smoothScrollTo(element, duration = 1000) {
      const targetPosition = element.offsetTop - 80;
      const startPosition = window.pageYOffset;
      const distance = targetPosition - startPosition;
      let startTime = null;

      function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const run = easeInOutQuad(timeElapsed, startPosition, distance, duration);
        window.scrollTo(0, run);
        if (timeElapsed < duration) requestAnimationFrame(animation);
      }

      function easeInOutQuad(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
      }

      requestAnimationFrame(animation);
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => header.init());
  } else {
    header.init();
  }
}

// Auto-initialize
initNavigation();
